import { createBrowserRouter } from 'react-router';
import { AppLayout } from '../components/app-layout.js';
import { AdminPage } from '../pages/admin-page.js';
import { CartPage } from '../pages/cart-page.js';
import { CatalogPage } from '../pages/catalog-page.js';
import { CheckoutResultPage } from '../pages/checkout-result-page.js';
import { NotFoundPage } from '../pages/not-found-page.js';
import { TraceabilityPage } from '../pages/traceability-page.js';
import { RecallsPage, RecallDetailPage } from '../pages/recalls-page.js';

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <CatalogPage /> },
      { path: '/cart', element: <CartPage /> },
      { path: '/checkout/result', element: <CheckoutResultPage /> },
      { path: '/trazabilidad', element: <TraceabilityPage /> },
      { path: '/admin', element: <AdminPage /> },
      { path: '/recalls', element: <RecallsPage /> },
      { path: '/recalls/:id', element: <RecallDetailPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
